import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';
// 收入预测版本 任务统计列表 -ylx
export const getRevenueForecastStatistics = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/todo/statistics',
        method: 'post',
        data
    });
};
// 收入预测版本 任务统计查询条件获取  分公司/行业/待办人/版本/行业大类 -ylx
export const getRevenueForecastCondition = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/todo/condition',
        method: 'post',
        data
    });
};
// 根据月份查询版本列表
export const listVersionByMonth = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/listVersionByMonth',
        method: 'post',
        data
    });
};
